import { IAssignmentPeriodsResponse, IGetNextOnlineLessonsResponse } from '@fsd-shared/models/assignment';
import { createSlice } from '@reduxjs/toolkit';
import { FetchStatus } from 'types/api';

import {
    getAllAssignmentPeriodsAction,
    getAssignmentPeriodsAction,
    getNextOnlineLessonsAction,
} from './assignment-actions';

export interface IAssignmentState {
    assignmentPeriods?: {
        assignment: number;
        periodsData: IAssignmentPeriodsResponse;
    }[];
    periodsData?: IAssignmentPeriodsResponse;
    nextOnlineLessonsList?: IGetNextOnlineLessonsResponse;
    gettingPeriodsDataStatus: FetchStatus;
    gettingNextOnlineLessonsStatus: FetchStatus;
}

const initialState: IAssignmentState = {
    gettingPeriodsDataStatus: FetchStatus.INITIAL,
    gettingNextOnlineLessonsStatus: FetchStatus.INITIAL,
};

const assignmentSlice = createSlice({
    name: 'assignment',
    initialState,
    reducers: {},
    /**
     *
     * @param builder
     */
    extraReducers: (builder) => {
        builder
            .addCase(getAllAssignmentPeriodsAction.pending, (state) => {
                state.gettingPeriodsDataStatus = FetchStatus.FETCHING;
                state.assignmentPeriods = undefined;
            })
            .addCase(getAllAssignmentPeriodsAction.fulfilled, (state, { payload }) => {
                state.gettingPeriodsDataStatus = FetchStatus.FETCHED;
                state.assignmentPeriods = payload;
            })
            .addCase(getAllAssignmentPeriodsAction.rejected, (state, { error }) => {
                state.gettingPeriodsDataStatus = FetchStatus.ERROR;
            });
        builder
            .addCase(getAssignmentPeriodsAction.pending, (state) => {
                state.gettingPeriodsDataStatus = FetchStatus.FETCHING;
                state.periodsData = undefined;
            })
            .addCase(getAssignmentPeriodsAction.fulfilled, (state, { payload }) => {
                state.gettingPeriodsDataStatus = FetchStatus.FETCHED;
                state.periodsData = payload;
            })
            .addCase(getAssignmentPeriodsAction.rejected, (state, { error }) => {
                state.gettingPeriodsDataStatus = FetchStatus.ERROR;
            });
        builder
            .addCase(getNextOnlineLessonsAction.pending, (state) => {
                state.gettingNextOnlineLessonsStatus = FetchStatus.FETCHING;
                state.nextOnlineLessonsList = undefined;
            })
            .addCase(getNextOnlineLessonsAction.fulfilled, (state, { payload }) => {
                state.gettingNextOnlineLessonsStatus = FetchStatus.FETCHED;
                state.nextOnlineLessonsList = payload;
            })
            .addCase(getNextOnlineLessonsAction.rejected, (state, { error }) => {
                state.gettingNextOnlineLessonsStatus = FetchStatus.ERROR;
            });
    },
});

// export const {} = assignmentSlice.actions;

export const assignmentReducer = assignmentSlice.reducer;
